export default __webpack_public_path__ + "static/logo-3c2f983448e2bb42535c6cd2b1945ade.png";